<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-16 10:14:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-12-27 08:54:23
-->
<template>
  <el-dialog
    class="assignSubject"
    title="从科目列表选择"
    top="5vh"
    :visible.sync="visible"
    width="960px"
  >
    <table-list
      v-if="visible"
      ref="subjectTable"
      :search-form="searchForm(this)"
      :data="subjectList"
      :columns="columns(this)"
      :pager="pager"
      @search="onSearch"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <div class="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="visible = false">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 搜索框配置
const searchForm = _this => [
  {
    label: '计划名称',
    type: 'select',
    prop: 'planId',
    children: _this.filterPlanList.map(item => ({
      value: item.key,
      label: item.value,
    })),
    remoteMethod: query => {
      _this.getFilterPlanList(query)
    },
    change: e => {
      _this.planId = e
      _this.getFilterPlanSubjectList()
    },
  },
  {
    label: '科目名称',
    type: 'select',
    prop: 'subjectId',
    children: _this.filterPlanSubjectList.map(item => ({
      value: item.key,
      label: item.value,
    })),
    remoteMethod: query => {
      _this.getFilterPlanSubjectList(query)
    },
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'planName',
    label: '计划名称',
    minWidth: 180,
    twoLines: true,
  },
  {
    prop: 'subjectName',
    label: '科目名称',
    minWidth: 180,
    twoLines: true,
  },
  {
    prop: 'subjectType',
    label: '类型',
    minWidth: 70,
  },
  {
    prop: 'jobLevel',
    label: '等级',
    minWidth: 70,
  },
  {
    prop: 'jobName',
    label: '职业',
    minWidth: 120,
  },
  {
    prop: 'workTypeName',
    label: '工种',
    minWidth: 120,
  },
  {
    prop: 'bindFlag',
    label: '分配',
    minWidth: 60,
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.bindFlag },
          on: {
            change: async v => {
              await _this.handleBindChange(v, row)
            },
          },
        }),
      ]
    },
  },
]
import { markPlanList, markBind, filterPlan, filterPlanSubject } from '@/api/system'
import to from 'await-to'
import TableList from '@/components/TableList'
export default {
  name: 'AssignSubject',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      queryParams: {},
      visible: false,
      filterPlanList: [],
      filterPlanSubjectList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      subjectList: [],
      select: [],
      id: '',
      planId: '',
    }
  },
  methods: {
    show(id) {
      this.userId = id
      this.queryParams = {}
      this.visible = true
      this.getList()
      this.getFilterPlanList()
    },
    async getFilterPlanList(query = '') {
      const [res, err] = await to(filterPlan({ planName: query }))
      if (err) return this.$message.warning(err.msg)
      this.filterPlanList = res.data
    },
    async getFilterPlanSubjectList(query = '') {
      const [res, err] = await to(filterPlanSubject({ subjectName: query, planId: this.planId }))
      if (err) return this.$message.warning(err.msg)
      this.filterPlanSubjectList = res.data
    },
    async getList() {
      const { current, size } = this.pager
      const [res, err] = await to(
        markPlanList({ current, size, ...this.queryParams, userId: this.userId }),
      )
      if (err) return this.$message.warning(err.msg)
      this.subjectList = res.data.list
      this.pager.total = res.data.total
    },
    async handleBindChange(v, row) {
      console.log(v, row)
      const [, err] = await to(
        markBind({
          relationId: row.relationId,
          subjectId: row.subjectId,
          userId: this.userId,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      // this.getList()
      row.bindFlag = v
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getList()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>
<style lang="scss" scoped>
.assignSubject {
  /deep/ .el-table__body-wrapper {
    height: calc(100% - 102px) !important;
  }
  /deep/.table-main {
    height: 473px;
    .el-table {
      height: 100% !important;
    }
  }
  .footer {
    display: flex;
    padding-top: 16px;
    .el-button {
      &:first-child {
        margin-left: auto;
      }
    }
  }
}
</style>
